import { StringHelper } from 'src/app/core/helpers/string.helper';
import { IContentBlock } from 'src/app/core/models/content-block.model';
import { IText, IVerifyContentBlock } from 'src/app/core/models/content.model';
import { IPage } from 'src/app/core/models/page.model';
import { IReCaptchaRequest } from 'src/app/core/models/reCaptcha.request';

export class EmailResetCodeRequest implements IReCaptchaRequest {
  constructor(cardNumber: string, phoneNumber: string, deviceId: string) {
    this.cardNumber = cardNumber;
    this.phoneNumber = phoneNumber;
    this.deviceId = deviceId;
  }

  cardNumber: string;
  phoneNumber: string;
  deviceId: string;
  reCaptchaToken: string;
  alternateReCaptchaToken?: string;
}

export class EmailResetCodeValidationRequest implements IReCaptchaRequest {
  constructor(code: string) {
    this.code = code;
  }

  code: string;
  reCaptchaToken: string;
  alternateReCaptchaToken?: string;
}

export class EmailResetCodePhoneValidationRequest extends EmailResetCodeValidationRequest {
  constructor(code: string, phoneNumber: string) {
    super(code);
    this.phoneNumber = phoneNumber;
  }

  phoneNumber: string;
}

export class EmailAddressResetRequest implements IReCaptchaRequest {
  constructor(
    code: string,
    cardNumber: string,
    phoneNumber: string,
    deviceId: string,
    birthDate: string,
    emailAddress: string,
    password: string
  ) {
    this.code = code;
    this.cardNumber = cardNumber;
    this.phoneNumber = phoneNumber;
    this.deviceId = deviceId;
    this.birthDate = StringHelper.toDate(birthDate)!;
    this.emailAddress = emailAddress;
    this.password = password;
  }

  code: string;
  cardNumber: string;
  phoneNumber: string;
  deviceId: string;
  birthDate: Date;
  emailAddress: string;
  emailAddressVerificationCode: string;
  password: string;
  reCaptchaToken: string;
  alternateReCaptchaToken?: string;
}

export interface IEmailResetForm extends IContentBlock, IVerifyContentBlock {
  title?: string;
  emailVerificationNotice?: string;
  emailVerificationText: IText;
  emailVerificationFallbackText: IText;
  birthDateNotice?: string;
  successPage: IPage;
}
